import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
export function XingIcon(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const color = t1 === undefined ? "currentColor" : t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <title>Xing</title>;
    t3 = <path d="M10.95,10.36c-.06.12-.9,1.58-2.5,4.4-.17.3-.39.45-.63.45h-2.32c-.27,0-.43-.27-.3-.51l2.46-4.32s0,0,0-.01l-1.57-2.7c-.15-.28.01-.5.3-.5h2.32c.26,0,.47.15.64.43l1.59,2.76ZM18.79,4.51l-5.13,9.02h0s3.27,5.95,3.27,5.95c.14.25,0,.5-.3.5h-2.32c-.27,0-.48-.14-.64-.43l-3.29-6.01c.12-.21,1.84-3.24,5.16-9.1.16-.29.37-.43.62-.43h2.34c.29,0,.44.24.3.5h0Z" />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== className || $[7] !== color || $[8] !== props) {
    t4 = <svg className={className} fill={color} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>{t2}{t3}</svg>;
    $[6] = className;
    $[7] = color;
    $[8] = props;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export function XingWithBorderIcon(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      color: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  t1 === undefined ? "currentColor" : t1;
  let t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <title>Xing</title>;
    t3 = <path d="M20 39.9777C9.44855 39.9777 0.864044 31.3932 0.864044 20.8417C0.864044 10.2903 9.44855 1.70178 20 1.70178C30.5515 1.70178 39.136 10.2863 39.136 20.8378C39.136 31.3892 30.5515 39.9737 20 39.9737V39.9777ZM20 3.29446C10.3245 3.29446 2.45274 11.1662 2.45274 20.8378C2.45274 30.5093 10.3245 38.3811 19.996 38.3811C29.6675 38.3811 37.5393 30.5093 37.5393 20.8378C37.5393 11.1662 29.6715 3.29446 20 3.29446Z" />;
    t4 = <path d="M18.6901 19.1694C18.5985 19.3406 17.392 21.4549 15.0827 25.5242C14.8318 25.9502 14.5252 26.1692 14.1709 26.1692H10.8223C10.4241 26.1692 10.2011 25.783 10.3843 25.4286L13.9359 19.1854C13.9359 19.1854 13.9479 19.1814 13.9359 19.1694L11.6783 15.2793C11.4553 14.8772 11.6942 14.5547 12.1163 14.5547H15.4649C15.8392 14.5547 16.1498 14.7657 16.3926 15.1838L18.694 19.1734L18.6901 19.1694ZM30.006 10.7362L22.5961 23.7563V23.7723L27.3104 32.3448C27.5095 32.7111 27.3224 33.0695 26.8724 33.0695H23.5159C23.1257 33.0695 22.8151 32.8624 22.5881 32.4404L17.834 23.7683C18.0052 23.4696 20.4858 19.0978 25.2837 10.6367C25.5187 10.2186 25.8173 10.0076 26.1836 10.0076H29.564C29.9742 10.0076 30.1971 10.354 30.002 10.7322L30.006 10.7362Z" />;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== className || $[8] !== props) {
    t5 = <svg className={className} fill="none" height="41" viewBox="0 0 40 41" width="40" xmlns="http://www.w3.org/2000/svg" {...props}>{t2}{t3}{t4}</svg>;
    $[7] = className;
    $[8] = props;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}